// function that counts only characters in the description and remove html tags
export const countTotalChars = (description: string) => {
  if (description) {
    const regex = /(<([^>]+)>)/gi
    const result = description.replace(regex, '')
    return result.length
  }
  return 0
}
